import React from "react";
import { ScrollView } from "react-native";
import { colors } from "src/assets";

const htmlSting = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>Untitled Document</title>
<!-- Bootstrap -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
</head>
<body>
<div  class="mx-2 mt-2">
<!-- body code goes here -->
<p>
プライバシーポリシー<br/>
<br/>
株式会社チョク（以下「弊社」といいます）は、弊社のサービスの利用者、弊社の取引先、弊社の従業員等の皆様（以下「利用者」といいます）の個人情報の重要性を認識し、適切に取り扱うために、以下のプライバシーポリシーを定めます。<br/>
利用者におかれましては、弊社が運営する各種サービス（以下「本サービス」といいます）のご利用のため、下記の「プライバシーポリシー」をお読みください。<br/>
<br/>
<br/>
1. 個人情報の定義<br/>
弊社は、個人情報とは、個人情報の保護に関する法律（以下「個人情報保護法」）の定めに従い、生存する個人に関する情報であって、氏名、住所、生年月日、などの特定の個人を識別することができる情報、及びマイナンバーなどの個人識別番号が含まれる情報と認識しております。<br/>
<br/>
<br/>
2. 個人情報の取得<br/>
弊社は、以下の場合に、個人情報を適正な方法により取得いたします。<br/>
<br/>
1.本サービス上でお客様自身に直接ご入力いただく方法<br/>
2. 利用者から電子メール、SNS、郵便、書面、電話、FAX等にてご提供いただく方法<br/>
3. 利用者による本サービスの利用・閲覧の際に収集する方法<br/>
4. 業務提携先および第三者から間接的に収集する方法<br/>
5. 利用者がSNS等の他サービスへの登録情報及びログイン情報を弊社に提供し、当該サービスから利用者の登録情報を収集する方法<br/>
6. 上記のほか、各サービス上で掲示した方法<br/>
<br/>
<br/>
3. 個人情報の利用目的<br/>
弊社は、取得した個人情報を以下の利用目的で利用します。<br/>
(1)本サービスに関する各種連絡や情報提供を行うため<br/>
(2)本サービスを提供するため<br/>
(3)本サービスにユーザー登録する際に必要な情報入力を簡略化するため<br/>
(4)利用者のお申込みにかかる本サービス間の情報連携のため<br/>
(5)電子メール配信のお申し込みの確認やメールを配信するため<br/>
(6)本サービスに関するご購入などの確認やお知らせをするため<br/>
(7)ご協力いただいた調査等に対する謝礼等をお送りするため<br/>
(8)ご応募いただいた懸賞等に対する景品等をお送りするため<br/>
(9)本サービスの利用状況等を調査・分析するため<br/>
(10)本サービスの改善や新サービスの開発のため<br/>
(11)行動履歴等の情報を分析し、本サービスに関する与信判断および与信管理を行うため<br/>
(12)本サービスの内容を利用者にあわせてカスタマイズするため<br/>
(13)本サービスに関する満足度を調査するため<br/>
(14)取得情報を統計的に処理した情報を、集約し調査結果として公表するため<br/>
(15)本サービス、新サービスその他の各種サービスに関する研究開発をするため<br/>
(16)本サービス、新サービスその他の各種サービスのマーケティングで利用するため<br/>
(17)調査のご協力依頼や各種イベントへのご参加をお願いしたり、その結果等をご報告するため<br/>
(18)弊社や第三者の広告の、利用者にあわせた配信または表示のため<br/>
(19)弊社や第三者の提供するサービス内に商品の情報を配信または表示するため<br/>
(20)本サービス運営上のトラブルの解決のため<br/>
(21)本サービスに関する不正利用防止や安全性の確保のため<br/>
<br/>
<br/>
4. 個人情報の第三者への提供<br/>
弊社は、以下に定める場合、取得情報を第三者に提供します。<br/>
(1)本サービスを提供するために弊社が必要と判断した、本サービスまたは本サービスに関連するサービス上での情報の提供の場合<br/>
(2)弊社が本サービスの運営および提供において必要と判断した場合<br/>
(3)代金決済、利用者からのお問い合わせへの対応、弊社から利用者へのお問い合わせ、関連するアフターサービスの提供等のために、配送業者、決済代行業者、業務委託先その他の第三者に提供する場合<br/>
(4)法令等に基づき、裁判所、捜査機関、行政機関、監督官庁その他公的機関から取得情報を提供するよう求められた場合<br/>
(5)第三者との紛争解決のため、または本サービスのユーザーもしくは第三者の権利や利益等を守るために情報提供が必要と弊社が判断した場合<br/>
(6)本サービスの利用状況等を調査・分析するため、弊社が委託する第三者に提供する場合<br/>
(7)弊社や第三者の広告の配信または表示のため、第三者に提供する場合<br/>
(8)弊社や第三者の提供するサービス内に本サービスに関わる情報を配信または表示するため、第三者に提供する場合<br/>
(9)学術研究の目的のため、学術研究機関に提供する場合<br/>
(10)クレジットカード発行会社が行う不正利用検知および不正利用防止のため、利用者の販売や購買の履歴、本サービスの登録情報、本サービスのご利用の状況等を、カード発行会社に提供する場合<br/>
(11)その他、弊社が取得情報の提供が必要と判断し、利用者等の同意を得られた場合<br/>
<br/>
<br/>
5. 外国への個人情報の第三者への提供<br/>
弊社は、取得情報を外国にある第三者に提供することがあります。この場合、当該国の個人情報保護に関する法規制を遵守しています。<br/>
<br/>
<br/>
6. 個人情報の共同利用について<br/>
弊社は、取得情報を弊社関係会社及び提携会社及び協力会社間で共同利用する場合があります。<br/>
<br/>
<br/>
7. 個人情報取扱業務の委託について<br/>
弊社は、取得情報の取扱いの全部または一部を業務委託先に委託することがあります。<br/>
<br/>
<br/>
8. Cookie等の利用について<br/>
Cookieの使用を許可するかにつきましては、お客様が設定できます。Cookieの使用を禁止した場合、本サービス及び広告設定を正常に利用できなくなる可能性があります。<br/>
弊社は、お客様のCookie情報や、閲覧された広告・ページ、お客様のご利用環境等の情報を自動的にお客様のブラウザから受け取り、サーバに記録し、本サービスログイン時の電子メールアドレス自動入力等の利便性向上のため、セッションの維持および保護等セキュリティの為、また、新しいサービスを検討するため、サービスや広告の内容をよりお客様に適したものとするために利用します。<br/>
<br/>
<br/>
9. Googleアナリティクスについて<br/>
弊社は、本サービスの利用状況等を調査・分析するため、本サービス上にGoogle社が提供するGoogleアナリティクスを利用しています。Googleアナリティクスの利用規約に関する説明についてはGoogleアナリティクスのサイトを、Google社のプライバシーポリシーに関する説明については同社のプライバシーポリシーをご覧ください。<br/>
<br/>
<br/>
10. ログ及び機器情報について<br/>
(1)ログ<br/>
弊社は、利用者が本サービス訪問時に自動で生成される、IPアドレス、ブラウザ種類、ブラウザ言語等を収集します。これらの情報はユーザー環境を分析し、より良いサービス提供のため、また正常なサービス提供を妨害する不正行為防止のために利用します。検索に関する記録は個人を特定することができない形態で保存および管理され、統計データ作成等の用途で利用します。<br/>
(2)機器情報<br/>
弊社は、端末の個体識別情報等の機器情報を収集する場合があります。これらの情報はより良いサービス提供のため、また正常なサービス提供を妨害する不正行為防止のために利用します。<br/>
<br/>
<br/>
11. 安全管理について<br/>
弊社では、収集した取得情報を、一般のユーザーがアクセスできない環境下にあるサーバにて安全に保管し、不正アクセス・紛失・破壊・改ざんまたは漏洩が生じないよう努めます。<br/>
<br/>
<br/>
12. プライバシーポリシーの変更<br/>
弊社は、個人情報保護を図るため弊社の判断により、法令等の変更その他の必要に応じて本ポリシーを改訂することがあります。都度、最新のプライバシーポリシーをご理解いただくようお願いします。<br/>
<br/>
<br/>
13. 個人情報の開示・訂正・利用停止等の手続<br/>
弊社は、個人情報保護法その他の法令等に基づき、利用者ご本人の個人情報の開示、訂正、追加、削除、利用停止、消去、第三者提供の停止、利用目的の通知の請求に対応いたします。但し、請求が本人確認不可能な場合や個人情報保護法の定める要件を満たさない場合にはご希望に添えないことがあります。<br/>
<br/>
<br/>
14. お問い合わせ<br/>
本ポリシーに関するご質問、ご相談、その他のお問い合わせにつきましては、info(アット)choku.meまでご連絡ください。<br/>
<br/>
<br/>
■会社情報<br/>
千葉県船橋市緑台2-6<br/>
株式会社チョク<br/>
</p>

<script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>
</div>
</body>
</html>`;

export type PrivacyPolicyScreenNavigationParam = undefined;

export const PrivacyPolicyScreen: React.FC = () => {
  return (
    <ScrollView
      style={{
        flex: 1,
        backgroundColor: colors.white,
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: htmlSting }} />
    </ScrollView>
  );
};
